import React, { useRef, useState } from "react";
import { Navigation } from "./types";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import ListItem from "./list-item";
import HamburgerButton from "./hamburger";
import { gsap } from "gsap";

import clsx from "clsx";

import useIsomorphicLayoutEffect from "../animations/useIsomorphicLayoutEffect";
import { CaretDownIcon } from "@radix-ui/react-icons";
import NavItemLabel from "./nav-item-label";

export type MobileNavProps = { nav: Navigation };
export const MobileNav: React.FC<MobileNavProps> = ({ nav }) => {
  const [open, setOpen] = useState(false);
  const el = useRef(null);
  const tl = useRef<gsap.core.Timeline | null>();

  const mobileMenuClases = clsx(
    "h-0 absolute w-full mt-2 bg-slate-300 dark:bg-gray-800 left-0"
  );
  //console.log(mobileMenuClases);

  useIsomorphicLayoutEffect(() => {
    //console.log(duration, x, y, delay, ease);
    const ctx = gsap.context(() => {
      tl.current = gsap
        .timeline({ reversed: true, paused: true })
        .to(el.current, {
          duration: 0.4,
          ease: "power3.inOut",
          height: "100vh",
          //zIndex: 50,
          opacity: 1,
        })
        .to("li", {
          duration: 0.3,
          opacity: 1,
          y: 20,
          ease: "power3.inOut",
          stagger: 0.05,
        });
    }, el);

    return () => ctx.revert(); // cleanup
  }, [tl]);

  const handleMenuClick = () => {
    setOpen(!open);
    tl.current?.reversed() ? tl.current.play() : tl.current?.reverse();
  };

  return (
    <div className="sm:hidden">
      <HamburgerButton onClick={handleMenuClick} />
      {open}
      {open && (
        <NavigationMenu.Root
          ref={el}
          orientation="vertical"
          className={mobileMenuClases}
        >
          <NavigationMenu.List className="bg-[#0c529c] text-center flex flex-col justify-center items-center">
            {nav.navigationItems.map((navItem) => {
              if (navItem.subNavigation) {
                return (
                  <NavigationMenu.Item
                    key={navItem.label}
                    className=" text-center flex flex-col justify-center items-center w-full"
                  >
                    <NavigationMenu.Trigger className="text-center text-white   hover:bg-violet3 focus:shadow-violet7 group flex select-none items-center justify-between gap-[2px] rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none outline-none focus:shadow-[0_0_0_2px]">
                    <NavItemLabel navItem={navItem} />
                      <CaretDownIcon
                        className="text-violet10 relative top-[1px] transition-transform duration-[250] ease-in group-data-[state=open]:-rotate-180"
                        aria-hidden
                      />
                    </NavigationMenu.Trigger>
                    <NavigationMenu.Content >
                      <div className="">
                        <ul className=" one m-0 grid list-none gap-x-[10px] p-[22px] sm:w-[500px] sm:grid-cols-[0.75fr_1fr]">
                          {navItem.subNavigation.listItems.map((listItem) => (
                            <ListItem
                              key={listItem.title}
                              url={listItem.url}
                              title={listItem.title}
                              message={listItem.message}
                            ></ListItem>
                          ))}
                        </ul>
                      </div>
                    </NavigationMenu.Content>
                  </NavigationMenu.Item>
                );
              } else {
                return (
                  <NavigationMenu.Item
                    key={navItem.label}
                     className=" text-center"
                  >
                    <NavigationMenu.Link
                      className="text-white hover:bg-gray-300 focus:shadow-violet7 block select-none rounded-[4px] px-3 py-2 text-[15px] font-medium leading-none no-underline outline-none focus:shadow-[0_0_0_2px]"
                      href={navItem.url}
                    >
                      <NavItemLabel navItem={navItem} />
                    </NavigationMenu.Link>
                  </NavigationMenu.Item>
                );
              }
            })}
          </NavigationMenu.List>
        </NavigationMenu.Root>
      )}
    </div>
  );
};

export default MobileNav;
